import { gql } from '@apollo/client';

export const updateRequestedUserMutation = gql`
  mutation ($pk_columns: requested_users_pk_columns_input!, $set: requested_users_set_input!) {
    update_requested_users_by_pk(pk_columns: $pk_columns, _set: $set) {
      email
    }
  }
`;
